export const MINDBOX_OPERATION_NAMES = {
  REGISTRATION: 'RegistraciyaNaSajte',
  AUTH: 'AvtorizaciyaNaSajte',
  AUTH_ON_CHECKOUT: 'Online.AuthenticatedOnOrder.JS',
  EXPLORE_PAGEVIEW: 'VisitPageExplore',
  CHECKOUT_PAGEVIEW: 'ProsmotrTura',
  HOTEL_PAGEVIEW: 'ViewHotelPage',
  FILL_TOURISTS_DATA: 'Online.FillingDataAboutTourists.JS',
} as const;
